import React from 'react';

function Zigzag() {
  return (
    <div className="zigzag position-relative">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

export default Zigzag;
